var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLenster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_663_1382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8845 14.76C13.4735 15.451 7.06273 15.5672 3.56532 13.6071C0.0679032 11.6471 1.76708 5.65407 5.3145 4.08038C8.86192 2.50669 14.2955 14.0691 13.8845 14.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.836 17.1589C14.247 17.8499 11.1453 23.297 7.64781 25.2571C4.15039 27.2171 -0.346839 22.7922 0.02286 19.0234C0.39256 15.2544 13.425 16.4678 13.836 17.1589Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9515 18.3984C16.7736 18.3984 20.0825 23.7295 20.0825 27.6496C20.0825 31.5696 13.8861 33.1378 10.7084 30.9425C7.53065 28.7473 15.1296 18.3983 15.9515 18.3984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1158 17.2405C18.5267 16.5494 24.9376 16.4334 28.435 18.3934C31.9324 20.3534 30.2333 26.3464 26.6858 27.9201C23.1383 29.4937 17.7048 17.9314 18.1158 17.2405Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1642 14.8414C17.7532 14.1503 20.8549 8.70318 24.3523 6.74309C27.8498 4.78306 32.347 9.20799 31.9774 12.9769C31.6076 16.7458 18.5751 15.5324 18.1642 14.8414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0484 13.6016C15.2264 13.6016 11.9175 8.27052 11.9175 4.35043C11.9175 0.430345 18.1139 -1.13776 21.2916 1.0575C24.4693 3.25275 16.8703 13.6017 16.0484 13.6016Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_663_1382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLenster);
export default __webpack_public_path__ + "static/media/lenster.2d0ae15a.svg";
export { ForwardRef as ReactComponent };